// extracted by mini-css-extract-plugin
export var cartContainer = "_pa-4";
export var gray = "_pa-1";
export var itemContainer = "_pa-2";
export var itemDetails = "_pa-3";
export var strong = "_pa-0";